import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d56907e")

_pushScopeId("data-v-1d56907e")
const _hoisted_1 = { class: "custom-money-dialog-view-root" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "限红", -1)
const _hoisted_4 = { class: "dialog-body" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, " 和限红: ", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "庄对限红: ", -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "闲对限红: ", -1)
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createVNode("span", null, "Super6 限红: ", -1)
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "龙七 : ", -1)
const _hoisted_14 = { key: 4 }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, "熊八: ", -1)
const _hoisted_16 = { key: 5 }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, "大老虎 : ", -1)
const _hoisted_18 = { key: 6 }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", null, "小老虎 : ", -1)
const _hoisted_20 = { key: 7 }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", null, " ", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode()
const _hoisted_23 = /*#__PURE__*/_createVNode("span", null, " ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["dialog-content", { desktop: !_ctx.isMobile, mobile: _ctx.isMobile }],
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("span", {
          class: "icon-close",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeDialog && _ctx.closeDialog(...args)))
        })
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("ul", null, [
          _createVNode("li", null, [
            _createVNode("span", null, _toDisplayString(_ctx.gameType === 'G002' ? '庄闲限红:' : '龙虎限红:') + " :", 1),
            _createVNode("span", null, "   " + _toDisplayString(_ctx.redAndBlueLimit()), 1)
          ]),
          _createVNode("li", null, [
            _hoisted_5,
            _createVNode("span", null, "   " + _toDisplayString(_ctx.greenLimit()), 1)
          ]),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_6, [
                _hoisted_7,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.pairLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_8, [
                _hoisted_9,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.pairLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_10, [
                _hoisted_11,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.greenLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_12, [
                _hoisted_13,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.dragonSevenLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_14, [
                _hoisted_15,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.bearEightLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_16, [
                _hoisted_17,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.bigTigerLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_18, [
                _hoisted_19,
                _createVNode("span", null, "   " + _toDisplayString(_ctx.littleTigerLimit()), 1)
              ]))
            : _createCommentVNode("", true),
          (_ctx.gameType === 'G002')
            ? (_openBlock(), _createBlock("li", _hoisted_20, [
                _hoisted_21,
                _hoisted_22,
                _hoisted_23
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 2)
  ]))
})